import { createSlice } from '@reduxjs/toolkit';
import merge from 'lodash.merge';

interface InteractionsState {
    currentInteraction: Record<string, unknown> | null;
}

const initialState: InteractionsState = {
    currentInteraction: null
};

const createNewBaseInteraction = () => ({
    instance_id: new Date().getTime(),
    identifier: '',
    shortIdentifier: '',
    label: '',
    startedTime: new Date().toISOString(),
    colorIndex: 0,
    idByInteraction: Math.random(),
    riskAnalysisList: {}
});

const interactionsReducer = createSlice({
    name: 'interactions',
    initialState,
    reducers: {
        setCurrentInteraction: (state, action) => {
            state.currentInteraction = action.payload;
        },
        closeInteraction: (state) => {
            state.currentInteraction = createNewBaseInteraction();
        },
        addInformationToInteraction: (state, action) => {
            if (state.currentInteraction) {
                const mergedInteractions = merge(state.currentInteraction, action.payload);
                state.currentInteraction = mergedInteractions;
            }
        }
    }
});

export const { setCurrentInteraction, closeInteraction, addInformationToInteraction } = interactionsReducer.actions;

export default interactionsReducer;
